<template>
  <div class="teams data--cards">
    <div class="page__header">
      <div class="page__title"> {{ $t(`users.${"team"}`) }}</div>
      <div class="page__right"> 
        <button
          v-if="canCreateTeam"
          class="users__button button button--default"
          @click="store.commit('setShowAddTeamModal', true)"
        >
          {{ $t(`users.${"addTeamBtn"}`) }}
        </button>
      </div>
    </div>

    <div class="table">
      <Loading v-if="teamsLoading" />
      <template v-else>
        <NoData v-if="teamCollectionError?.status === 403" type="no-permission" />
        <NoData v-else-if="!teams.length" :type="'teams'" />
        <template v-else>
          <div class="table__header box box--default">
            <div class="table__label table__label--small team__logo"></div>
            <div class="table__label table__label--large">
              {{ $t(`teams.${"tableHeader"}.${"name"}`) }}
            </div>
            <div class="table__label table__label--medium">
              FINMA Nr.
            </div>
            <div class="table__label table__label--medium">
               {{ $t(`teams.${"tableHeader"}.${"domain"}`) }}
            </div>
            <div class="table__label table__label--large">
              {{ $t(`teams.${"tableHeader"}.${"address"}`) }}
            </div>
            <div class="table__label table__label--large">
              {{ $t(`teams.${"tableHeader"}.${"mandateTypes"}`) }}
            </div>

            <div
              class="table__label table__label--small"
              v-if="hasAnyTeamActions"
            ></div>
          </div>

          <div class="table__body">
            <Team
              v-for="team in teams"
              :key="team.id"
              :team="team"
              :deleteTeam="deleteTeam"
            />
          </div>
        </template>
      </template>
    </div>

  </div>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import Team from "@/components/Teams/Team";
import Loading from "@/partials/Loading";
import NoData from "@/partials/NoData";

const store = useStore();

// Computed properties
const teamsLoading = computed(() => store.getters.teamsLoading);
const teams = computed(() => store.getters.teams);
const teamCollectionError = computed(() => store.getters.teamCollectionError);
const isSuperAdmin = computed(() => store.getters.isSuperAdmin);
const canCreateTeam = computed(() => {
  if (isSuperAdmin.value) return true;
  return store.getters.hasGlobalPermission("team_create");
});
const hasAnyTeamActions = computed(() => {
  if (isSuperAdmin.value) return true;

  return teams.value.some((team) =>
    ["team_edit", "team_delete", "tax_access"].some((ability) =>
      store.getters.hasTeamPermission(ability, team.id)
    )
  );
});

// Methods
const deleteTeam = ({ display, message, action, id }) => {
  store.commit("setDeleteModal", {
    display,
    message,
    action,
    id,
  });
};

// Lifecycle
onMounted(async () => {
  store.commit("setTeamsLoading", true);

  await store.dispatch("getTeams");

  store.commit("setTeamsLoading", false);
});
</script>

<style scoped lang="scss">
.teams {
  height: 100%;

  &__button {
    width: 190px;
  }
  .table {
    margin-bottom: 20px;
    height: calc(100% - 40px - 20px - 20px - 30px);
   .table__label--small{
      max-width: 70px;
    }
    &--last {
      max-width: 45px;
      height: initial;
    }
   .team__logo {
     max-width: 70px;
   }
  }  
}

@media (max-width: 600px) {
  .table__body {
    padding-bottom: 5px;
  }
}
</style>
